import React, { useContext } from "react";
import USER from "components/context/UserContext";
import styles from "styles/profilepage.module.css";
import SelectedEvents from "./SelectedEvents";
import RegisteredEvents from "./RegisteredEvents";

// const token =
// "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJuYW1lIjoiRGl2eWEga3VtYXIgQmFpZCIsImVtYWlsIjoiZGl2eWFrdW1hcmJhaWQuZGtiLjIwMDFAZ21haWwuY29tIiwiaXNBZG1pbiI6dHJ1ZSwiY29udGFjdCI6Iis5MTkxMjMwNjU0NzEiLCJfaWQiOiI2MjRjN2MwYWYyNzA2NzI0ODg5YTM2NWYiLCJpYXQiOjE2NDk0NDAxODYsImV4cCI6MTY0OTUyNjU4Nn0.AOeU0d5Hj5k3IaVxhAoL5MNWp9zNIM9aUzR7Zv1yx2o";

function UserProfile() {
  const { user } = useContext(USER);

  if (!user.data) {
    return "";
  }

  return (
    <div className={styles.root}>
      <div className={styles.profilePage}>
        <div className={styles.profileDetails}>
          <div className={styles.profileImage}>
            <img src={user.data.avatar} alt="" />
          </div>
          <div className={styles.allDetails}>
            <div className={styles.userDetails}>
              <div className={styles.profileText}>
                <div className={styles.profileTxt}>
                  <span style={{ color: "rgb(230, 46, 46) " }}>Name </span>
                  {user.data.name}
                </div>

                <div className={styles.profileEmail}>
                  <span style={{ color: "rgb(230, 46, 46) " }}>Email </span>
                  {user.data.email}
                </div>

                <div className={styles.profileTxt}>
                  <span style={{ color: "rgb(230, 46, 46) " }}>Contact </span>
                  {user.data.contact}
                </div>
              </div>
            </div>
            <div className={styles.educationalDetails}>
              <div className={styles.profileText}>
                <div className={styles.profileTxt}>
                  <span style={{ color: "rgb(230, 46, 46) " }}>
                    Department{" "}
                  </span>
                  {user.data.stream}
                </div>
                <div className={styles.profileTxt}>
                  <span style={{ color: "rgb(230, 46, 46) " }}>Year </span>
                  {user.data.year}
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className={styles.profileUserEvents}>
          <RegisteredEvents />
          <SelectedEvents />
        </div>
      </div>
    </div>
  );
}

export default UserProfile;
